@if (form && definition) {
  <div
    class="flex flex-col"
    >
    <label class="soft-label top"
      >{{ definition.title }}
      @if (definition.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      <soft-draw-input
        [formControl]="form|formControl:definition.name"
        [readonly]="definition.readonly | booleanRule: form.value"
        softFieldValidation
        >
      </soft-draw-input>
    </div>
  }
